import { message } from "antd";
import Joi from "joi-browser";
import { useMemo, useState } from "react";
import Form from "V2.0/components/Form";
import { putTTSSettings } from "../../service";

interface RimeAISettings {
  rimeAISpeechSpeed: number;
}

const template = [
  {
    name: "rimeAISpeechSpeed",
    label: "Speed",
    description:
      "Controls the speed of the generated speech. Higher the number the slower the pace",
    type: "slider",
    min: 0.75,
    max: 1.3,
    step: 0.1,
  },
];

const schema = {
  rimeAISpeechSpeed: Joi.number(),
};

function getConfigurableRimeAISettings(settings) {
  const { rimeAISpeechSpeed } = settings;

  return {
    rimeAISpeechSpeed,
  };
}

function RimeAI(props) {
  const {
    rimeAISettings,
    ttsServiceProvider,
    syncAssistant,
    workspaceId,
    assistantId,
    onClose,
  } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage] = useState({});

  const inputField = useMemo(() => {
    return getConfigurableRimeAISettings(rimeAISettings);
  }, [rimeAISettings]);

  const handleSaveSettings = async (data) => {
    setLoading(true);
    message.loading("Saving");

    const payload = {
      ttsServiceProvider,
      rimeAISettings: data,
    };

    try {
      const response = await putTTSSettings({
        workspaceId,
        assistantId,
        payload,
      });

      if (response.status === 200) {
        message.destroy();
        setLoading(false);
        message.success("Saved");
        syncAssistant((prevAssistant) => {
          return { ...prevAssistant, ttsSettings: response.data };
        });
        onClose();
      }
    } catch (e) {
      setLoading(false);

      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to save settings");
    }
  };

  return (
    <div>
      <Form
        inputField={inputField}
        template={template}
        schema={schema}
        buttonInfo={{ label: "Save", style: "right-side" }}
        loading={loading}
        setLoading={setLoading}
        onSubmit={handleSaveSettings}
      />
    </div>
  );
}

export default RimeAI;
